import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c1a1218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrganizationalManagementBox" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "租户 ", -1))
const _hoisted_5 = { class: "OrganizationalManagement-table" }
const _hoisted_6 = { class: "dialogBox" }
const _hoisted_7 = { class: "dialog-footer" }

import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance,
  toRaw,
  computed,
} from "vue";
import {
  FormInstance,
  TableInstance,
  FormRules,
  ElMessage,
} from "element-plus";
import { useRouter } from "vue-router";
import { setField } from "../../utiles/utiles";
import { Search, RefreshRight, Plus } from "@element-plus/icons-vue";
import {
  getDeptTree,
  deptTreeByCompCode,
  saveOrUpdate,
  updateEnableFlag,
  getCompanyOption,
} from "@/views/OrganizationalManagement/api";
import { getListCompanyInfo } from "@/views/Login/api";
import { el } from "element-plus/es/locale";
interface ruleFormConfigItem {
  id: string;
  compCode: string;
  parentId: string;
  deptName: string;
  deptCode: string;
  enableFlag: string;
  verifyTargetOrCollar: any;
  earTagGenerator: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : "";
const tableRef = ref<TableInstance>();
const queryFormRef = ref<FormInstance>();
const ruleFormRef = ref<FormInstance>();
const Router = useRouter();

const queryForm = reactive({
  compCode: userInfo.compCode,
  deptName: "",
  tenantId: "",
  pageIndex: 1,
  pageSize: 10,
});
const verifyTypes = ref<any>([]);
const talentArr = ref<any>([]);
const tableData = ref<any>([]);
const dialogVisible = ref(false);
const dialogTitle = ref<string>("新增机构");
const formSize = ref("default");
const ruleForm = reactive<ruleFormConfigItem>({
  id: "",
  compCode: "",
  parentId: "",
  deptName: "",
  deptCode: "",
  enableFlag: "Y",
  verifyTargetOrCollar: null,
  earTagGenerator: null,
});
const validateDeptcode = (rule: any, value: any, callback: any) => {
  if (value) {
    // let reg = new RegExp(/^[0-9]{1,8}$/)
    let reg = /^\d+$/;
    if (!reg.test(value)) {
      callback("机构代码验证纯数字");
    } else {
      callback();
    }
  } else {
    callback("请输入机构代码");
  }
};
const rules = reactive<FormRules>({
  parentId: [
    {
      required: true,
      message: "请选择上级机构",
      trigger: "change",
    },
  ],
  deptName: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
  deptCode: [{ required: true, validator: validateDeptcode, trigger: "blur" }],
});


const timestamp = "TIME_STAMP";
const deptCode = "DEPT_CODE";

const { proxy }: any = getCurrentInstance();
onMounted(() => {
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  onSearch();
  getListCompanyInfos();
});
const verifyTypeMap = {
  EAR_TAG: "耳标",
  COLLAR: "项圈",
  NONE: "自动生成",
  EXTERNAL_EAR_TAG: "选择外部耳标号",
};

// 定义排序优先级
const verifyTypeOrder = {
  EAR_TAG: 1,
  COLLAR: 2,
  NONE: 3,
  EXTERNAL_EAR_TAG: 4,
};

//获取租户配置
const getCompanyConfig = (arr: string[]) => {
  verifyTypes.value = transformVerifyTypes(arr);
};
// 转换并排序
const transformVerifyTypes = (arr:any) => {
  if (!arr || !Array.isArray(arr)) return [];
  console.log("arr", arr);
  
  // 确保只处理存在的键值
  const validItems = arr.filter(item => verifyTypeMap.hasOwnProperty(item));
  console.log("validItems", validItems);
  
  return validItems
    .map(item => ({
      label: verifyTypeMap[item],
      value: item
    }))
    .sort((a, b) => {
      // 处理未定义顺序的情况（默认放到最后）
      const orderA = verifyTypeOrder[a.value] ?? 999;
      const orderB = verifyTypeOrder[b.value] ?? 999;
      return orderA - orderB;
    });
};
// 计算属性，用于过滤表格数据
const filterTree = (tree, filterText) => {
  const filterTextLower = filterText.toLowerCase();

  const dfs = (node) => {
    if (!node) return null;

    // 检查当前节点是否匹配
    const isMatch = node.name.toLowerCase().includes(filterTextLower);

    if (isMatch) {
      // 如果当前节点匹配，保留当前节点并递归保留所有子节点
      return {
        ...node,
        children: node.children ? node.children.map(dfs) : [], // 递归处理子节点
      };
    }

    // 如果当前节点不匹配，继续递归查找子节点中是否有匹配的节点
    if (node.children) {
      const filteredChildren = node.children.map(dfs).filter(Boolean); // 过滤掉不匹配的子节点
      if (filteredChildren.length > 0) {
        // 如果有匹配的子节点，则返回以当前节点为根的子树（但不包括当前节点本身的属性）
        return {
          children: filteredChildren, // 仅包含匹配的子节点及其子树
        };
      }
    }

    // 如果没有匹配的子节点，返回null表示不匹配该分支
    return null;
  };

  // 从树的根节点开始搜索
  return dfs(tree);
};

// 在你的 Vue 组件中，你可以这样使用这个函数：
const filteredTableData = computed(() => {
  console.log("queryForm.deptName", queryForm.deptName);

  if (!queryForm.deptName) {
    return tableData.value; // 如果没有过滤文本，则返回原始数据
  }
  return filterTree(tableData.value, queryForm.deptName);
});

const getListCompanyInfos = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
  });
};

const updateEnableFlagFn = (value: string, id: string) => {
  console.log(value, id);
  let param = {
    id: id,
    enableFlag: value,
  };
  updateEnableFlag(param)
    .then((res: any) => {
      ElMessage({
        type: "success",
        message: "切换成功",
      });
      onSearch();
    })
    .catch((err: any) => {
      onSearch();
    });
};
const tableRowClassName = ({
  row,
  rowIndex,
}: {
  row: any;
  rowIndex: number;
}) => {
  if (queryForm.deptName !== "") {
    if (row.name.indexOf(queryForm.deptName) > -1) {
      tableScrollMove(rowIndex);
      return "success-row";
    }
  }
  return "";
};
const tableScrollMove = (index = 0) => {
  if (!tableRef.value!) return;
  let vmEl = tableRef.value!.$el;
  if (!vmEl) return;
  //计算滚动条的位置
  const targetTop = vmEl
    .querySelectorAll(".el-table__body tr")
    [index].getBoundingClientRect().top;
  const containerTop = vmEl
    .querySelector(".el-table__body")
    .getBoundingClientRect().top;
  const containerScrollTop = vmEl.querySelector(".el-table__body-wrapper");
  containerScrollTop.scrollTo(0, targetTop - containerTop);
};
const onSearch = () => {
  // getDeptTree().then((res: any) => {
  //   tableData.value = res;
  // });
  if (queryForm.compCode) {
    deptTreeByCompCode(queryForm.compCode).then((res: any) => {
      tableData.value = res;
    });
  } else {
    // getDeptTree().then((res: any) => {
    //   tableData.value = res;
    // });
    queryForm.compCode = userInfo.compCode;
  }
};
const newlyAdded = (row: any) => {
  dialogTitle.value = "新增机构";
  dialogVisible.value = true;
  setTimeout(() => {
    ruleForm.parentId = row.id;
    ruleForm.compCode = row.compCode;
    console.log("row.verifyTargetOrCollarList",row.verifyTargetOrCollarList);
    getCompanyConfig(row.verifyTargetOrCollarList);
  }, 200);

  console.log("ruleForm.compCode", ruleForm.compCode);
};
const resetForm = (formEl: FormInstance | undefined, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogVisible.value = false;
  }
  console.log("重置成功", ruleForm);
};
const transferVerifyType = (value: string) => {
  switch (value) {
    case "EAR_TAG":
      return "耳标";
    case "COLLOR":
      return "项圈";
    case "NONE":
      return "自动生成";
    default:
      return "";
  }
};
const edit = (row: any, type: boolean) => {
  dialogTitle.value = type ? "新增机构" : "编辑机构";
  dialogVisible.value = true;
  ruleForm.compCode = row.compCode;

  if (type) {
    setTimeout(() => {
      ruleForm.parentId = row.parentId;
    }, 200);
  } else {
    setTimeout(() => {
      for (let key in row) {
        const k = key as keyof ruleFormConfigItem;
        setField(ruleForm, k, row[k]);
      }

      ruleForm.deptName = row.name;
      ruleForm.deptCode = Number(row.code);

      console.log("row.verifyTargetOrCollarList",row.verifyTargetOrCollarList);
      getCompanyConfig(row.verifyTargetOrCollarList);
    }, 200);
  }
};

const handleClose = (formEl: any) => {
  if (!formEl) return;
  formEl.resetFields();
  ruleForm.id = "";
};
const changeCompCode = (item, node) => {
  ruleForm.compCode = item.compCode;
  console.log("ruleForm.compCode", ruleForm.compCode);
};
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      saveOrUpdate(ruleForm).then((res: any) => {
        ElMessage({
          type: "success",
          message: dialogTitle.value + "成功",
        });
        onSearch();
        dialogVisible.value = false;
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(userInfo).id === '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_select, {
              modelValue: queryForm.compCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.compCode) = $event)),
              placeholder: "请选择",
              onChange: onSearch
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.compCode,
                    label: item.compName,
                    value: item.compCode
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        inline: true,
        model: queryForm,
        class: "demo-form-inline",
        ref_key: "queryFormRef",
        ref: queryFormRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "机构名称",
            prop: "deptName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryForm.deptName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.deptName) = $event)),
                placeholder: "机构名称",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: onSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查 询")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                plain: "",
                icon: _unref(RefreshRight),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (resetForm(queryFormRef.value, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重 置")
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        ref_key: "tableRef",
        ref: tableRef,
        border: "",
        "default-expand-all": "",
        style: {"width":"100%"},
        height: "100%",
        "row-key": "id",
        "row-class-name": tableRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "机构名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "code",
            label: "机构代码"
          }),
          _createVNode(_component_el_table_column, {
            prop: "weight",
            label: "创建时间",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "stopEnable",
            label: "机构状态",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_switch, {
                modelValue: scope.row.enableFlag,
                "onUpdate:modelValue": ($event: any) => ((scope.row.enableFlag) = $event),
                "active-value": "Y",
                "inactive-value": "N",
                onChange: ($event: any) => (updateEnableFlagFn($event, scope.row.id))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "150",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (newlyAdded(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新 增 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (edit(scope.row, false)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编 辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event)),
        title: dialogTitle.value,
        width: "500px",
        onClose: _cache[11] || (_cache[11] = ($event: any) => (handleClose(ruleFormRef.value))),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_el_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (resetForm(ruleFormRef.value, true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取 消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确 定 ")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            rules: rules,
            "label-width": "120px",
            class: "demo-ruleForm",
            size: formSize.value,
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "上级机构",
                prop: "parentId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    style: {"width":"100%"},
                    placeholder: "请选择上级机构",
                    "check-strictly": "",
                    clearable: "",
                    modelValue: ruleForm.parentId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.parentId) = $event)),
                    data: tableData.value,
                    "render-after-expand": false,
                    onCurrentChange: changeCompCode
                  }, null, 8, ["modelValue", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "机构名称",
                prop: "deptName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.deptName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.deptName) = $event)),
                    maxlength: "20",
                    placeholder: "请输入机构名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "机构代码",
                prop: "deptCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.deptCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.deptCode) = $event)),
                    type: "number",
                    placeholder: "请输入机构代码"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "启用状态",
                prop: "enableFlag"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: ruleForm.enableFlag,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.enableFlag) = $event)),
                    "active-value": "Y",
                    "inactive-value": "N"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "验证耳标、项圈",
                prop: "verifyTargetOrCollar"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: ruleForm.verifyTargetOrCollar,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.verifyTargetOrCollar) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(verifyTypes.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                          key: item.value,
                          label: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "size"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})